import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { ElevatedButton } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { downloadLink } from 'helpers/decorators'
import styles from './assessor-summary.styl'

const DownloadButton = downloadLink(ElevatedButton)

export default class AssessorSummary extends Component {
  static propTypes = {
    activityId: PropTypes.number.isRequired,
    activityUploadReport: PropTypes.func.isRequired
  }

  state = {
    loading: false
  }

  handleFileSelection = e => {
    const { activityId } = this.props
    const file = e.target.files[0]

    if (!file) {
      return
    }

    this.setState({ loading: true })

    this.props
      .activityUploadReport(activityId, file)
      .then(() => {
        this.setState({ loading: false })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  render() {
    const { activityId } = this.props
    const { loading } = this.state

    return (
      <div className={styles.wrap}>
        <div className={styles.el}>
          <DownloadButton
            url={`/activities/${activityId}/summary-report-generation`}
            secondary
            link
          >
            <FormattedMessage
              id="button.download_summary_for_assessor"
              defaultMessage="button.download_summary_for_assessor"
            />
          </DownloadButton>
        </div>
        <div className={`${styles.el} ${styles.text}`}>
          <FormattedMessage
            id="label.download_report_and_upload_signed_version"
            defaultMessage="Download report and upload signed version"
          />
        </div>

        {loading && (
          <div className={styles.el}>
            <div className={styles.loader}>
              <MaterialLoader small />
            </div>
          </div>
        )}
        {!loading && (
          <div className={styles.el}>
            <div className={styles.upload}>
              <button type="button" className={styles.btn}>
                <FormattedMessage id="button.upload" defaultMessage="Upload" />
              </button>
              <input
                className={styles.picker}
                type="file"
                onChange={this.handleFileSelection}
                accept="application/pdf"
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}
